import { forwardRef } from 'react';
import { clsx } from 'clsx';

const Card = forwardRef(({ 
  children, 
  className = '', 
  padding = 'p-6',
  ...props 
}, ref) => {
  return (
    <div
      ref={ref}
      className={clsx(
        'card',
        padding,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default Card;
